import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { FormsModule,ReactiveFormsModule } from '@angular/forms';
// external dependencies
import { QuillModule } from 'ngx-quill';

// components
import { HelperFormWysiwygExtendedComponent } from './wysiwyg-extended/wysiwyg-extended.component';


@NgModule({
    imports: [
        CommonModule,
        QuillModule.forRoot({
            customModules: [],
            customOptions: []}),
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        HelperFormWysiwygExtendedComponent
    ],
    exports: [
        HelperFormWysiwygExtendedComponent
    ],

})
export class HelpersEditorModule { }
